import { FC } from 'react'

const LinkIcon: FC = () => (
  <svg
    width="40"
    height="26"
    viewBox="0 0 40 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="0.5"
      width="40"
      height="25"
      rx="4"
      fill="#00D66F"
    />
    <path
      d="M18.0187 5H14C14.7812 8.26562 17.0648 11.057 19.9219 12.8125C17.0602 14.5672 14.7812 17.3594 14 20.625H18.0187C19.0148 17.6039 21.7727 14.9789 25.1609 14.4422V11.1766C21.7672 10.6453 19.0094 8.02031 18.0187 5Z"
      fill="#011E0F"
    />
  </svg>
)

export default LinkIcon
